import React, { useEffect, useState } from "react";
import { Select2 } from "../../forms/Select2";
import { useGestionNeumaticos } from "../../../pages/GestionNeumaticos/useGestionNeumaticos";
import { formatDate, notify } from "../../../../utils/utils";
import { DatePickerABX } from "../../pickers/DatePicker";
import imagenVolante from '../../../../assets/images/imagenVolante.webp'
import { useModal } from "../../../../hooks/useModal";
import { Modal } from "../../modal/Modal";

const EnlazeDesenlazeNeumatico = ({
    closeModalContenedor = () => {},
    ocultarParaEdicion = false,
    codigoOrdenTrabajoProp = 0
}) => {

    const classNameInput = "containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 caret-white"   
    const ejePosicionDefault = {
        eje: 0,
        posicion: 0,
        codUnidadNeumatico: 0
    }

    const {
        listadoMovimientoNeumaticos,
        movimientos,
        listadoDetalladoMovimiento,
        detalladoMovimiento,

        listarComboOrdenTrabajo,
        ordenesTrabajo,

        listarCabeceraDetalleNeumatico,
        cabeceraDetalleNeumatico,

        listarNeumaticosSinEnlaze,
        neumaticosSinEnlaze,
        
        consultaNeumaticoEnlazado,
        neumaticoEnlazado,

        listarNeumaticoEstado,
        estadosNeumaticos,


        infoNeumatico,
        setInfoNeumatico,
        infoNeumaticoDefault,
        editarInfoNeumatico,



        editarNeumatico,
        enlazarNeumaticoUnidad,
        desenlazarNeumaticoUnidad,

        listarNeumaticosPorOT,
        neumaticosPorOT
    } = useGestionNeumaticos()

    const [ordenTrabajo,setOrdenTrabajo] = useState(0)
    const [fechaRegistroModal,setFechaRegistroModal] = useState(new Date())
    const [ejePosicionSelecccionada,setEjePosicionSeleccionada] = useState(ejePosicionDefault)
    const [textoAnulacion,setTextoAnulacion] = useState('')
    const [existeOrden,setExisteOrden] = useState(true)
    const [isOpenDesenlazar, openModalDesenlazar, closeModalDesenlazar] = useModal()

    useEffect(() => {
        const funcionReady = async () => {
            await listadoMovimientoNeumaticos()
            await listarComboOrdenTrabajo()
            await listarNeumaticoEstado()
        }

        funcionReady()
    }, [])

    useEffect(() => {
        if(codigoOrdenTrabajoProp && ordenesTrabajo.length != 0){     // SOLO SE VA A EJECUTAR CUANDO EL CODIGO DEL COMPONENTE TENGA VALOR
            ordenesTrabajo.some(e => e.codOrdenTrabajo == codigoOrdenTrabajoProp) && funcionCambioCabeceraNeumatico(codigoOrdenTrabajoProp)
            setExisteOrden(ordenesTrabajo.some(e => e.codOrdenTrabajo == codigoOrdenTrabajoProp))
        }
    },[ordenesTrabajo])

    useEffect(() => {
        if(Object.keys(neumaticoEnlazado).length != 0){
            setInfoNeumatico(Object.assign({},infoNeumaticoDefault,neumaticoEnlazado))
        }
    },[neumaticoEnlazado])

    const funcionCambioCabeceraNeumatico = async (valor) => {
        setOrdenTrabajo(valor)
        setEjePosicionSeleccionada(ejePosicionDefault)
        setInfoNeumatico(infoNeumaticoDefault)
        await listarCabeceraDetalleNeumatico(valor == 0 ? 0 : ordenesTrabajo.find(e => e.codOrdenTrabajo == valor).codUnidad)
        await listarNeumaticosPorOT(valor)
    }

    const funcionEditar = async () => {
        const jsonData = await editarNeumatico({
            codNeumatico: infoNeumatico.codNeumatico,
            codigoNeumatico: infoNeumatico.codigoNeumatico,
            medidaInterna: infoNeumatico.medidaInterna,
            medidaMedia: infoNeumatico.medidaMedia,
            medidaExterna: infoNeumatico.medidaExterna,
            presion: infoNeumatico.presion,
            profundidad: infoNeumatico.profundidad,
            codNeumaticoEstado: infoNeumatico.codNeumaticoEstado,
            fechaRegistroActualizacion: formatDate(fechaRegistroModal),
            codOrdenTrabajo: ordenTrabajo
        })
        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')
        if(jsonData.CodResultado == 1){
            closeModalContenedor()
            codigoOrdenTrabajoProp && funcionCambioCabeceraNeumatico(codigoOrdenTrabajoProp)
        }
    }

    const funcionEnlazar = async () => {
        if(JSON.stringify(ejePosicionDefault) == JSON.stringify(ejePosicionSelecccionada)){
            notify('Seleccione un neumatico para realizar la accion','info')
            return
        }

        const jsonData = await enlazarNeumaticoUnidad({
            codUnidad: ordenesTrabajo.find(e => e.codOrdenTrabajo == ordenTrabajo)?.codUnidad,
            nroEje: ejePosicionSelecccionada.eje,
            nroPosicion: ejePosicionSelecccionada.posicion,
            codNeumatico: infoNeumatico.codNeumatico,
            fechaRegistro: formatDate(fechaRegistroModal),
            codOrdenTrabajo: ordenTrabajo
        })
        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')
        if(jsonData.CodResultado == 1){
            closeModalContenedor()
            codigoOrdenTrabajoProp && funcionCambioCabeceraNeumatico(codigoOrdenTrabajoProp)
        }
    }

    const funcionDesenlazar = async () => {
        if(JSON.stringify(ejePosicionDefault) == JSON.stringify(ejePosicionSelecccionada)){
            notify('Seleccione un neumático para realizar la acción','info')
            return
        }

        const jsonData = await desenlazarNeumaticoUnidad({
            codUnidadNeumatico: ejePosicionSelecccionada.codUnidadNeumatico,
            fechaRegistro: formatDate(fechaRegistroModal),
            codOrdenTrabajo: ordenTrabajo,
            comentarioDesenlace: textoAnulacion
        })
        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')
        if(jsonData.CodResultado == 1){
            closeModalDesenlazar()
            closeModalContenedor()
            codigoOrdenTrabajoProp && funcionCambioCabeceraNeumatico(codigoOrdenTrabajoProp)
        }
    }

    return (
        existeOrden ? 
        <>
            <div className='flex flex-col w-full gap-5'>
                <div className='flex lg:flex-col lg:gap-4 justify-between'>
                    <div className={`flex gap-4 ${ocultarParaEdicion ? 'invisible' : ''}`}>
                        <div className='w-[150px]'>
                            <Select2
                                opciones={[
                                    {
                                        text: '--Seleccionar--',
                                        value: 0
                                    },
                                    ...ordenesTrabajo.map((data,i) => {
                                        return {
                                            text: data.nomDocumento,
                                            value: data.codOrdenTrabajo
                                        }
                                    })
                                ]}
                                value={ordenTrabajo}
                                functionChangeValue={(valor) => funcionCambioCabeceraNeumatico(valor)}
                            ></Select2>
                        </div>
                        <input disabled value={ordenesTrabajo.find(e => e.codOrdenTrabajo == ordenTrabajo)?.placaUnidad || '-'} type='text' className={`${classNameInput} w-[150px] text-center`} />
                    </div>
                    <div className='flex gap-4 text-xs lg:h-[30px] items-center px-2 border border-gray-700 rounded-md shadow-black shadow-lg'>
                        <div className='flex gap-2 items-center'><i className="fa fa-circle text-black" aria-hidden="true"></i>Enlazado</div>
                        <div className='flex gap-2 items-center'><i className="fa fa-circle text-green-600" aria-hidden="true"></i>Disponible</div>
                        <div className='flex gap-2 items-center'><i className="fa fa-circle text-purple-600" aria-hidden="true"></i>Seleccionado</div>
                    </div>
                </div>
                <div className='border rounded p-10 lg:px-2'>
                    <div className='w-full h-full relative'>
                        <div className='w-full h-[150px] border-2 border-black bg-[#9fa69f] absolute rounded-xl'>
                            <div className='w-full h-full flex justify-around'>
                                {
                                    cabeceraDetalleNeumatico.map((data,i) => {
                                        const neumaticosAgrupados = [
                                            data.detalleNeumatico.filter(num => Number(num.nroPosicion) % 2 == 0),
                                            data.detalleNeumatico.filter(num => Number(num.nroPosicion) % 2 != 0),
                                        ]
                                        return(
                                            <div key={i+1} className='flex flex-col justify-between'>
                                                {
                                                    neumaticosAgrupados.map((data2,j) => {
                                                        return(
                                                            <div key={j+1} className={`${j==0 ? '-translate-y-1/2' : 'translate-y-1/2'} w-12 flex flex-col gap-2`}>
                                                                {
                                                                    data2.map((data3,k) => {
                                                                        return(
                                                                            <div 
                                                                                onClick={() => {
                                                                                    setEjePosicionSeleccionada({
                                                                                        eje: data.nroEje,
                                                                                        posicion: data3.nroPosicion,
                                                                                        codUnidadNeumatico: data3.codUnidadNeumatico
                                                                                    })
                                                                                    if(data3.codNeumatico != 0){
                                                                                        consultaNeumaticoEnlazado(data3.codNeumatico)
                                                                                    }else{
                                                                                        setInfoNeumatico(infoNeumaticoDefault)
                                                                                    }
                                                                                }} 
                                                                                key={k+1} 
                                                                                className={`${data3.codNeumatico != 0 ? 'bg-black' : 'bg-green-600'} ${(data.nroEje == ejePosicionSelecccionada.eje && data3.nroPosicion == ejePosicionSelecccionada.posicion) ? '!bg-purple-600' : 'cursor-pointer'} w-full h-4 border-2 border-white rounded`}
                                                                            ></div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className='w-full h-[150px] flex justify-between'>
                            <div className='h-full flex items-end'>
                                <div className='h-full w-[30px] flex items-center justify-center'>
                                    <div className='-rotate-90 text-black font-bold'>Adelante</div>
                                </div>
                                <img className='w-[50px] h-[50px] mb-[10px] ml-[10px] -rotate-90' src={imagenVolante}/>
                            </div>
                            <div className='h-full w-[30px] flex items-center justify-center'>
                                <div className='-rotate-90 text-black font-bold'>Atrás</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='p-5 border rounded flex flex-col gap-5'>
                    <fieldset className='border p-8 lg:px-2 relative rounded'>
                        <legend className='absolute -translate-y-1/2 left-5 top-0 bg-[#2f3134] px-2 font-bold'>Neumático</legend>
                        <div className={`${ocultarParaEdicion ? 'w-full' : 'grid grid-cols-2 '} gap-6 lg:gap-2`}>
                            <div className='grid grid-cols-2 lg:grid-cols-1 gap-4'>
                                <label>Código:</label>
                                {
                                    infoNeumatico.codigoNeumatico == ''  ?
                                        <select 
                                            value={infoNeumatico.codNeumatico} 
                                            onChange={(e) => {
                                                editarInfoNeumatico('codNeumatico',e.target.value)
                                                const obtenerDataNeumatico = neumaticosPorOT.find(data => data.codNeumatico == e.target.value)
                                                editarInfoNeumatico('medidaMedia',obtenerDataNeumatico?.medidaMedia || '')
                                                editarInfoNeumatico('medidaExterna',obtenerDataNeumatico?.medidaExterna || '')
                                                editarInfoNeumatico('profundidad',obtenerDataNeumatico?.profundidad || '')
                                                editarInfoNeumatico('codNeumaticoEstado',obtenerDataNeumatico?.codNeumaticoEstado || 0)
                                                editarInfoNeumatico('medidaInterna',obtenerDataNeumatico?.medidaInterna || '')
                                                editarInfoNeumatico('presion',obtenerDataNeumatico?.presion || '')
                                            }} 
                                            className={classNameInput}
                                        >
                                            <option value={0}>--Seleccione--</option>
                                            {
                                                neumaticosPorOT.map((data,i) => <option key={i+1} value={data.codNeumatico}>{data.codigoNeumatico || '-'}</option>)
                                            }
                                        </select>
                                    :
                                        <input value={infoNeumatico.codigoNeumatico} className={classNameInput} type='text' disabled />
                                }
                                {
                                    ocultarParaEdicion ? ''
                                    :   
                                    <>
                                        <label>M.Media:</label>
                                        <input disabled={infoNeumatico.codigoNeumatico == '' ? true : false} type='number' min={0} value={infoNeumatico.medidaMedia} onChange={(e) => editarInfoNeumatico('medidaMedia',e.target.value)} className={classNameInput} />
                                        <label>M.Externa:</label>
                                        <input disabled={infoNeumatico.codigoNeumatico == '' ? true : false} type='number' min={0} value={infoNeumatico.medidaExterna} onChange={(e) => editarInfoNeumatico('medidaExterna',e.target.value)} className={classNameInput} />
                                        <label>Profundidad:</label>
                                        <input disabled={infoNeumatico.codigoNeumatico == '' ? true : false} type='number' min={0} value={infoNeumatico.profundidad} onChange={(e) => editarInfoNeumatico('profundidad',e.target.value)} className={classNameInput} />
                                    </>
                                }
                            </div>
                            {
                                ocultarParaEdicion ? ''
                                : 
                                <>
                                    <div className='grid grid-cols-2 lg:grid-cols-1 gap-4'>
                                        <label>Estado:</label>
                                        <select disabled={infoNeumatico.codigoNeumatico == '' ? true : false} value={infoNeumatico.codNeumaticoEstado} onChange={(e) => editarInfoNeumatico('codNeumaticoEstado',e.target.value)} className={classNameInput}>
                                            <option value={0}>--Seleccione--</option>
                                            {
                                                estadosNeumaticos.map((data,i) => <option key={i+1} value={data.codNeumaticoEstado}>{data.nomNeumaticoEstado}</option>)
                                            }
                                        </select>
                                        <label>M.Interna:</label>
                                        <input disabled={infoNeumatico.codigoNeumatico == '' ? true : false} type='number' min={0} value={infoNeumatico.medidaInterna} onChange={(e) => editarInfoNeumatico('medidaInterna',e.target.value)} className={classNameInput} />
                                        <label>Presión:</label>
                                        <input disabled={infoNeumatico.codigoNeumatico == '' ? true : false} type='number' min={0} value={infoNeumatico.presion} onChange={(e) => editarInfoNeumatico('presion',e.target.value)} className={classNameInput} />
                                        <label>Fecha:</label>
                                        <div>
                                            <DatePickerABX date={fechaRegistroModal} setDate={setFechaRegistroModal}></DatePickerABX>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </fieldset>
                    <div className='flex gap-5 justify-end text-sm'>
                        {
                            ordenTrabajo == 0 ?
                                ''
                            :
                                infoNeumatico.codigoNeumatico != '' ? 
                                    <>
                                        {
                                            ocultarParaEdicion ? ''
                                            : <button onClick={funcionEditar} className='hover:scale-110 px-2 py-1 rounded-md bg-orange-600 w-[100px]'>Editar</button>
                                        }
                                        <button onClick={() => {openModalDesenlazar();setTextoAnulacion('')}} className='hover:scale-110 px-2 py-1 w-[100px] rounded-md bg-red-600'>Desenlazar</button>
                                    </>
                                :
                                    <button onClick={funcionEnlazar} className='hover:scale-110 px-2 py-1 w-[100px] rounded-md bg-green-600'>Enlazar</button>
                        }
                    </div>
                </div>
            </div>
            <Modal 
                isOpen={isOpenDesenlazar}
                title={'Desenlazar neumático'}
                action={funcionDesenlazar}
                closeModal={closeModalDesenlazar}
                textButtons = {{ confirm: 'Si', denied: 'No' }}
                isDragrable = {false}
            >
                <div className='flex flex-col gap-5 items-center justify-center w-[400px] p-5'>
                    <label className='text-xl'>¿Está seguro de desenlazar el neumático?</label>
                    <textarea value={textoAnulacion} onChange={e => setTextoAnulacion(e.target.value)} placeholder='(Motivo)' className= {`${classNameInput} w-full h-[80px] p-5 caret-white`}></textarea>
                </div>
            </Modal>
        </>
        : ''
    )
};

export default EnlazeDesenlazeNeumatico;
